import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetValidatedAccesses, HttpGetValidatedAccessesOptions} from '@/features/agenda/http/agenda.http'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {raise} from '@/utilities/helpers'
import {Access} from '@/features/accesses/types'

interface UseGetValidatedAccessesOptions {
    params: Omit<HttpGetValidatedAccessesOptions['params'], 'patient'> & {patient?: string}
    options?: Omit<UseQueryOptions<Access[], AxiosError<ErrorResponseData>>, 'queryKey' | 'queryFn'>
}

export const useGetValidatedAccesses = ({params, options}: UseGetValidatedAccessesOptions) => {
    return useQuery({
        queryKey: [QUERY_KEYS.AGENDA_EVENTS, 'validated-accesses', params],
        queryFn: () =>
            httpGetValidatedAccesses({
                params: {...params, patient: params.patient ?? raise('patient is undefined')}
            }),
        ...options
    })
}
